import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IntegrationStatus } from 'src/app/models/integration-status';
import moment from 'moment';
import { BusinessLogicService } from 'src/app/services/business-logic.service';

@Component({
  selector: 'app-integration-status',
  templateUrl: './integration-status.component.html',
  styleUrls: ['./integration-status.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntegrationStatusComponent implements OnInit, OnChanges {

  @Input() status: IntegrationStatus;

  public isUnknown: boolean = false;
  public isRunning: boolean = false;
  public isCompleted: boolean = false;
  public isContinuedAsNew: boolean = false;
  public isFailed: boolean = false;
  public isCanceled: boolean = false;
  public isTerminated: boolean = false;
  public isPending: boolean = false;
  public date: string;
  public isDeleting: boolean = false;
  public dayOfWeek: number = null;

  constructor(private businessLogicService: BusinessLogicService) { }

  // checks numerical values to determine what a specific instances state is. state will determine which image is shown.
  // see lines 2-10 on integration-status.component.html
  ngOnInit(): void {
    this.recomputeViewModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      this.recomputeViewModel();
    }
  }

  private recomputeViewModel(): void {
    if (!this.status) return;

    // reset flags
    this.isUnknown = false;
    this.isRunning = false;
    this.isCompleted = false;
    this.isContinuedAsNew = false;
    this.isFailed = false;
    this.isCanceled = false;
    this.isTerminated = false;
    this.isPending = false;

    this.date = moment(new Date(this.status.createdTime)).format('MMM DD YYYY hh:mm A');
    this.dayOfWeek = new Date(this.status.createdTime).getDay() + 1;

    switch (this.status.runtimeStatus) {
      case -1: this.isUnknown = true; break;
      case 0: this.isRunning = true; break;
      case 1: this.isCompleted = true; break;
      case 2: this.isContinuedAsNew = true; break;
      case 3: this.isFailed = true; break;
      case 4: this.isCanceled = true; break;
      case 5: this.isTerminated = true; break;
      case 6: this.isPending = true; break;
      default: break;
    }
  }

  // requests durable function service to cancel a current running instance
  terminateInstance() {
    this.businessLogicService.terminateInstance(this.status.instanceId, this.status.alias, this.status.name);
  }

  // requests durable function service to remove a specified instance from the history
  deleteInstance() {
    this.isDeleting = true;
    this.businessLogicService.deleteInstance(this.status.instanceId, this.status.alias, this.status.name);
  }
}
